import React, { useEffect } from "react";

function SalesforceOnboarding() {
  useEffect(() => {
    window.location.href = `https://${process.env.REACT_APP_V2_PATH}/integrations/crm/salesforce-crm/setup`;
  }, []);
  return null;
}

export default SalesforceOnboarding;
